<template>
	<div class="tl">
		<div class="tl-head">
			<span class="tl-title">{{ titolo }}</span>
			<v-spacer></v-spacer>
			<template v-if="tab > 0 && trans[tab]">
				<v-btn x-small text color="primary" title="Riporta il testo della prima lingua" @click="$emit('copia', tab)"
					><v-icon left x-small>mdi-clipboard-multiple-outline</v-icon>Copia dalla prima lingua</v-btn
				>
				<v-btn x-small text color="primary" @click="$emit('traduci', tab, trans[tab].lang)">
					<v-avatar size="14px" tile class="mr-1"><v-img :src="require('@/assets/images/Google_Translate_logo.svg')" /></v-avatar>Traduci
				</v-btn>
			</template>
		</div>
		<v-tabs v-model="tab" show-arrows height="36" class="tl-tabs">
			<v-tab v-for="(t, key) in trans" :key="t.lang" class="tl-tab">
				<v-avatar size="14px" tile class="mr-2"><img :src="bandiera(t.lang)" :alt="t.lang" /></v-avatar>
				{{ String(t.lang).toUpperCase() }}
				<span v-if="key === 0" class="tl-default">predefinita</span>
			</v-tab>
		</v-tabs>
		<v-tabs-items v-model="tab" class="tl-items">
			<v-tab-item v-for="t in trans" :key="t.lang" eager>
				<v-textarea v-if="textarea" v-model="t.message" :placeholder="placeholder" auto-grow rows="2" outlined dense hide-details class="mt-3" />
				<v-text-field v-else v-model="t.message" :placeholder="placeholder" outlined dense hide-details class="mt-3" />
			</v-tab-item>
		</v-tabs-items>
	</div>
</template>

<script>
// un testo breve in tutte le lingue attive (messaggio in testata, note della pagina prodotto)
export default {
	name: 'TestiLingua',
	props: {
		// [{ lang, message }]
		trans: { type: Array, default: () => [] },
		titolo: { type: String, required: true },
		placeholder: { type: String, default: '' },
		textarea: { type: Boolean, default: false },
	},
	data() {
		return { tab: 0 };
	},
	methods: {
		bandiera(lang) {
			try {
				return require(`@/assets/images/flag/${String(lang).toUpperCase()}.svg`);
			} catch (e) {
				return require('@/assets/images/flag/map.svg');
			}
		},
	},
};
</script>

<style scoped>
.tl {
	margin-top: 12px;
	padding: 10px 12px 12px;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	background: #fafbfd;
}
.tl-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
}
.tl-title {
	font-size: 12px;
	font-weight: 600;
	color: #5f6b7a;
}
.tl-tabs {
	border-bottom: 1px solid #e1e7ef;
}
.tl-tabs ::v-deep .v-tabs-bar {
	background: transparent !important;
}
.tl-tab {
	text-transform: none;
	letter-spacing: 0;
	font-weight: 600;
	min-width: 64px;
	font-size: 12px;
}
.tl-default {
	font-size: 10px;
	font-weight: 500;
	text-transform: uppercase;
	color: #5f6b7a;
	margin-left: 6px;
}
.tl-items {
	background: transparent !important;
}
</style>
